import styles from './ShimmerLoader.module.scss';

interface ShimmerLoaderProps {
  children: (props: { 'data-shimmer-item': boolean }) => JSX.Element;
}

const ShimmerLoader = ({ children }: ShimmerLoaderProps) => {
  return (
    <div className={styles['shimmer-loader']}>
      <div className={styles['shimmer-loader-wrapper']}>{children({ 'data-shimmer-item': true })}</div>
    </div>
  );
};

export default ShimmerLoader;
